(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aicon-trust-points"] && !Shopify.designMode) return;
  try {
    
  // ★ 3つのイラストで「安心・安全への取り組み」を開く（日高さん指示 2026-08-24）★
  //
  //   シートは購入ボックス（sections/aicon-product-buybox.liquid）の中にあり、
  //   このセクションとは別。document 経由で開く合図だけを送る。
  //
  //   ★ シートが無いページでは押せるようにしない ★
  //     トップページにもこのセクションは置ける。押しても何も起きないボタンを
  //     作らないため、シートの有無を見てから role / tabindex / クラスを足す。
  //
  //   ★ セクションは複数回描かれ得るので、要素ごとに1回だけ配線する ★
  //     data-aicon-tp-wired で二重配線を防ぐ（テーマエディタの再描画対策）。
  (function () {
    function wire() {
      if (!document.querySelector('[data-aicon-trust-sheet]')) return;

      document.querySelectorAll('[data-aicon-tp-item]').forEach(function (item) {
        if (item.dataset.aiconTpWired === '1') return;
        item.dataset.aiconTpWired = '1';

        item.classList.add('is-tappable');
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');

        function open() {
          document.dispatchEvent(new CustomEvent('aicon:trust-sheet:open'));
        }

        item.addEventListener('click', open);
        // キーボード操作。role="button" は Enter / Space で押せることが期待される
        item.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          open();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wire, { once: true });
    } else {
      wire();
    }
    // テーマエディタでセクションを差し替えたときも配線し直す
    document.addEventListener('shopify:section:load', wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
